import { isMobile } from 'mobile-device-detect';
import $ from 'jquery';
import '../scss/jafzaVideo.scss';
import Header from './components/header';
import gsap from 'gsap';
import { Global } from './common/global';

let isInTransition = false;
let pageActivated = false;
let currentSlide = 0;
let slideData = [
  {
    videoUrl: 'https://www.youtube.com/embed/SmHcCCJnu7U',
    title: 'LOREM IPSUM',
    subtitle: 'Solar Sit Amet',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
    img: 'Logo07.png',
  },
  {
    videoUrl: 'https://www.youtube.com/embed/uepWAGy_RA4',
    title: 'DOLOR SIT',
    subtitle: 'Amet Consectetur',
    description: 'Second slide content goes here.',
    img: 'Logo01.jpg',
  },
  {
    videoUrl: 'https://www.youtube.com/embed/CZVG_UfRCHs',
    title: 'DOLOR SIT',
    subtitle: 'Amet Consectetur',
    description: 'Second slide content goes here.',
    img: 'Logo04.png',
  },
  {
    videoUrl: 'https://www.youtube.com/embed/F6J5g0MhZlE',
    title: 'DOLOR SIT',
    subtitle: 'Amet Consectetur',
    description: 'Second slide content goes here.',
    img: 'Logo05.png',
  },
  {
    videoUrl: 'https://www.youtube.com/embed/rb9hhShQ0NY',
    title: 'DOLOR SIT',
    subtitle: 'Amet Consectetur',
    description: 'Second slide content goes here.',
    img: 'Logo08.png',
  },
  {
    videoUrl: 'https://www.youtube.com/embed/ker_75V6Abc',
    title: 'DOLOR SIT',
    subtitle: 'Amet Consectetur',
    description: 'Second slide content goes here.',
    img: 'Logo03.png',
  },
  {
    videoUrl: 'https://www.youtube.com/embed/hOWYOVetj88',
    title: 'DOLOR SIT',
    subtitle: 'Amet Consectetur',
    description: 'Second slide content goes here.',
    img: 'Logo02.png',
  },
  {
    videoUrl: 'https://www.youtube.com/embed/NyHLrb5T3dc',
    title: 'DOLOR SIT',
    subtitle: 'Amet Consectetur',
    description: 'Second slide content goes here.',
    img: 'Logo06.png',
  },
  {
    videoUrl: 'https://www.youtube.com/embed/VUgoh-ZAAME',
    title: 'DOLOR SIT',
    subtitle: 'Amet Consectetur',
    description: 'Second slide content goes here.',
    img: 'Logo09.png',
  },
  {
    videoUrl: 'https://www.youtube.com/embed/mpE1tqP30vk',
    title: 'DOLOR SIT',
    subtitle: 'Amet Consectetur',
    description: 'Second slide content goes here.',
    img: 'Logo10.png',
  },
];

fetch('./partials/header.html')
  .then((res) => res.text())
  .then((html) => {
    document.getElementById('header').innerHTML = html;
    activateHeader();
  });
fetch('./partials/footer.html')
  .then((res) => res.text())
  .then((html) => {
    document.getElementById('footer').innerHTML = html;
  });
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let utm_source = urlParams.get('utm_source');
let utm_medium = urlParams.get('utm_medium');
let utm_campaign = urlParams.get('utm_campaign');
let utm_term = urlParams.get('utm_term');
Global.U_ID = localStorage.getItem('U_ID');

if (
  (Global.U_ID == null || Global.U_ID == '' || Global.U_ID == 0,
  Global.U_ID == undefined)
) {
  $.ajax({
    type: 'POST',
    url: 'https://newsfeedsmartapp.com/Jafza/api/createUser.php',
    data: {
      page: 'home_click',
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
    },
    dataType: 'json',
    success: function (resultData) {
      var res = resultData;
      Global.U_ID = res.UID;
      localStorage.setItem('U_ID', Global.U_ID);
    },
  });
} else {
  $.ajax({
    type: 'POST',
    url: 'https://newsfeedsmartapp.com/Jafza/api/valueUpdator.php',
    data: {
      saveType: 'voices_of_jafza_click',
      uniqID: Global.U_ID,
    },
    dataType: 'json',
    success: function (resultData) {
      var res = resultData;
    },
  });
}
const slider = document.getElementById('slider');
const totalSlides = slider.children.length;

// Bind event listeners to the correct context
document.querySelector('#prev').addEventListener('click', prevSlide.bind(this));
document.querySelector('#next').addEventListener('click', nextSlide.bind(this));

// Function to update the slider position
updateSliderPosition = updateSliderPosition.bind(this);

// updateSliderPosition(); // Call it to position the slider initially

generateSlide(slideData);

function activateHeader() {
  new Header();

  //   setTimeout(()=>{
  //     document.querySelector("#header header").classList.add('active')
  //     document.querySelector("#footer footer").classList.add('active')
  //   },1000)
}

function generateSlide(data) {
  const slider = document.querySelector('#slider .content');

  slider.innerHTML = '';

  data.forEach((item, i) => {
    const slideDiv = document.createElement('div');
    slideDiv.classList.add('slide');

    const videoContainerDiv = document.createElement('div');
    videoContainerDiv.classList.add('videoContainer');

    const iframe = document.createElement('iframe');
    const iframeDiv = document.createElement('div');
    iframeDiv.classList.add('iframeDiv');
    iframe.src = item.videoUrl;

    iframe.onload = function (slideDiv) {
      if (!pageActivated && i == 0) {
        animateLoader(slideDiv);
      } else {
        slideDiv.classList.add('active2');
      }
      // const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      // const video = iframeDoc.querySelector('video');
      // if (video) {
      //   video.onloadeddata = () => {
      //     console.log('Video inside iframe has loaded data');
      //   };
      // }
    }.bind(this, slideDiv);

    iframe.classList.add('iframes');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');

    iframeDiv.append(iframe);
    videoContainerDiv.appendChild(iframeDiv);

    const logoDiv = document.createElement('img');
    logoDiv.classList.add('logo');
    if (i == 0) {
      logoDiv.classList.add('active');
    }

    logoDiv.src = `ui/voice_of_jafza/${item.img}`;
    videoContainerDiv.appendChild(logoDiv);

    const videoDetailsDiv = document.createElement('div');
    videoDetailsDiv.classList.add('videoDetails');

    const sec1Div = document.createElement('div');
    sec1Div.classList.add('sec1');
    const regularTextDiv = document.createElement('div');
    regularTextDiv.classList.add('regular-text');
    //   regularTextDiv.textContent = item.title;
    const boldTextDiv = document.createElement('div');
    boldTextDiv.classList.add('bold-text');
    //   boldTextDiv.textContent = item.subtitle;
    sec1Div.appendChild(regularTextDiv);
    sec1Div.appendChild(boldTextDiv);

    const sec2Div = document.createElement('div');
    //           const logoDiv = document.createElement('img');
    //   logoDiv.classList.add('logo');
    //   logoDiv.src = `ui/voice_of_jafza/${item.img}`;
    //   sec2Div.appendChild(logoDiv);

    //   const descriptionTextDiv = document.createElement('div');
    //   descriptionTextDiv.classList.add('regular-text');
    //   descriptionTextDiv.textContent = item.description;
    //   sec2Div.appendChild(descriptionTextDiv);

    videoDetailsDiv.appendChild(sec1Div);
    videoDetailsDiv.appendChild(sec2Div);

    slideDiv.appendChild(videoContainerDiv);
    slideDiv.appendChild(videoDetailsDiv);

    slider.appendChild(slideDiv);
  });
}
function animateLoader(slideDiv) {
  pageActivated = true;
  document.querySelector('.celebrartion').classList.add('active');
  gsap.to('#loaderMaskRect', {
    attr: { width: Math.min(window.innerWidth, window.innerHeight * 2) },
    duration: 1, // seconds
    ease: 'power2.out',
    onComplete: function () {
      setTimeout(() => {
        document.querySelector('.page_loader').classList.add('loaded');
        setTimeout(() => {
          activatePage();
        }, 0);
        setTimeout(() => {
          slideDiv.classList.add('active2');
        }, 100);
      }, 250);
    }.bind(this),
  });
}
function activatePage() {
  document.querySelector('#slideNumber').classList.add('active');
  setTimeout(() => {
    document.querySelector('#header header').classList.add('active');
    document.querySelector('#footer footer').classList.add('active');
    updateSliderPosition();
  }, 500);
}
function updateSliderPosition() {
  const slider = document.querySelector('#slider .content');
  const offset = -currentSlide * 100;
  slider.style.transform = `translateX(${offset}vw)`;

  let counter = document.querySelector('#slideNumber span');
  setTimeout(() => {
    counter.innerHTML = `0${currentSlide + 1} / ${
      slideData.length < 10 ? '0' : ''
    }${slideData.length}`;
  }, 1000);

  if (currentSlide == 0) {
    document.querySelector('#prev').classList.remove('active');
  } else {
    document.querySelector('#prev').classList.add('active');
  }

  if (currentSlide == slideData.length - 1) {
    document.querySelector('#next').classList.remove('active');
  } else {
    document.querySelector('#next').classList.add('active');
  }
}

function nextSlide() {
  if (isInTransition) return false;
  isInTransition = true;

  const slider = document.querySelector('#slider .content');
  const totalSlides = slider.children.length;

  if (currentSlide < totalSlides - 1) {
    $('.slide').eq(currentSlide).find('.logo').removeClass('active');
    currentSlide++;
    playSlideAnimations();
  }
}

function prevSlide() {
  if (isInTransition) return false;
  isInTransition = true;
  if (currentSlide > 0) {
    $('.slide').eq(currentSlide).find('.logo').removeClass('active');
    currentSlide--;
    playSlideAnimations();
  }
}

function playSlideAnimations() {
  $('.slide').addClass('active');

  for (let i = 1; i <= slideData.length; i++) {
    i >= currentSlide &&
      document.querySelector(`#bg${i}Mask rect`).classList.remove('disabled');
  }

  if (currentSlide > 0) {
    document
      .querySelector(`#bg${Math.max(currentSlide, 1)}Mask rect`)
      .classList.add('disabled');
  }

  // active
  setTimeout(() => {
    updateSliderPosition();
    setTimeout(() => {
      setTimeout(() => {
        isInTransition = false;
      }, 250);
      $('.slide').eq(currentSlide).find('.logo').addClass('active');
      $('.slide').removeClass('active');
    }, 750);
  }, 100);
}
